import { fmtShort } from "../../data/mockData";

export default function CustomTooltip({ active, payload, label }) {
  if (!active || !payload?.length) return null;

  return (
    <div style={{ background: "var(--bg-card)", border: "1px solid var(--border-strong)", borderRadius: "10px", padding: "10px 14px" }}>
      <div style={{ fontSize: "11px", color: "var(--text-muted)", fontFamily: "'JetBrains Mono', monospace", marginBottom: "6px" }}>{label}</div>
      {payload.map((p, i) => (
        <div key={i} style={{ fontSize: "13px", color: p.color || "#D4AF37", fontFamily: "'Capsule Sans', sans-serif", fontWeight: "600" }}>
          {p.name}: {fmtShort(p.value)}
        </div>
      ))}
    </div>
  );
}
